import { AlertTriangle } from "lucide-react";

/* MOCK badge — placed on every UI block that renders mock data.
   Per design guidelines: amber, monospace, ultra-small. */
export function MockBadge({ className = "", label = "MOCK", dataTestid }) {
  return (
    <span
      data-testid={dataTestid || "mock-badge"}
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 mono align-middle whitespace-nowrap ${className}`}
      style={{
        background: "rgba(176,116,18,0.12)",
        color: "rgb(176,116,18)",
        border: "1px solid rgba(176,116,18,0.30)",
        fontSize: 9,
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        lineHeight: 1,
      }}
    >
      <AlertTriangle size={9} strokeWidth={2.4} className="flex-shrink-0" />
      {label}
    </span>
  );
}

export default MockBadge;
